export default "__VITE_ASSET__BmOj96SX__"